import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import styled from '@emotion/styled'
import { breakpoints } from '../../constants'

export default ({ closeVinScan, onSuccess, onError, updateGlobalState }) => {
  const [WebscannerComponent, setWebscannerComponent] = useState()

  useEffect(() => {
    updateGlobalState({ fireAnalytics: 'timbuybkhome_selltrade_vinscan_open' })
  }, [updateGlobalState])

  useEffect(() => {
    import('@vauto/webscanner-react').then(Module => {
      setWebscannerComponent(Module)
    })
  }, [])

  return WebscannerComponent && WebscannerComponent.WebScanner
    ? ReactDOM.createPortal(
        <ScanningDiv>
          <WebscannerComponent.WebScanner
            onScan={result => {
              if (result) {
                if (result.error) {
                  updateGlobalState({ fireAnalytics: 'timbuybkhome_selltrade_vinscan_error' })
                  onError(result.error)
                } else {
                  const vinResult = result.vin.replace(/[iIoOqQ ]/g, '')

                  updateGlobalState({ fireAnalytics: 'timbuybkhome_selltrade_vinscan_success' })

                  if (vinResult.length === 17 && result.isValid) {
                    onSuccess && onSuccess(vinResult)
                  }
                }
                closeVinScan()
              }
            }}
            enabledScanners={['ONED', 'TWOD']}
            onCancel={closeVinScan}
            showTips={false}
            showKeyboard={false}
            showFlash={false}
            logo={<img alt="ico" src={__PATH_PREFIX__ + '/KBBICO-Logo-White.png'} />}
            bottomContent={
              <StyledH2>
                Scan your VIN barcode located inside the driver's doorjamb.
                <br />
                Rotate your phone if needed.
              </StyledH2>
            }
          />
        </ScanningDiv>,
        document.body
      )
    : ''
}

const ScanningDiv = styled.div`
  > div {
    display: flex;
    align-content: stretch;
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: auto;
    width: 100%;
    height: 100%;
    max-width: 100vw;
    max-height: 100vh;
    background: white;
    z-index: 1301;
    .webscanner-outer {
      flex: 1;
    }
    .webscanner-bottom-content {
      align-self: center;
    }
  }
`
const StyledH2 = styled.h2`
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  width: 100%;
  margin-bottom: 8px;
  margin-top: 8px;

  @media (min-width: ${breakpoints.lg}px) {
    font-size: 18px;
    margin-bottom: 16px;
    margin-top: 16px;
  }
`
